export const environment = {
  production: false,

   /* API Solicitação Autorização CONFIG */
   solicitacaoautorizacao_api_hapvida: 'https://app.hapvida.com.br/wssolicitacaoautorizacao/v1',//PRODUÇÃO
   solicitacaoautorizacao_api_hapvida_homolog: 'http://app-homolog.hapvida.net.br/wssolicitacaoautorizacao/v1',//HOMOLOGAÇÃO
   solicitacaoautorizacao_api_hapvida_desenv: 'http://app-desenv.hapvida.net.br/wssolicitacaoautorizacao/v1',//DESENVOLVIMENTO
   solicitacaoautorizacao_api_hapvida_localhost: 'http://localhost:8080/wssolicitacaoautorizacao/v1',//localhost

  /* API Jornada - Serviços Online CONFIG */
  jornada_api_hapvida: 'https://app.hapvida.com.br/api/wssrvonline/v1',//PRODUÇÃO
  jornada_api_hapvida_homolog: 'http://app-homolog.hapvida.com.br/api/wssrvonline/v1',//HOMOLOGAÇÃO
  jornada_api_hapvida_desenv: 'http://app-desenv.hapvida.com.br/api/wssrvonline/v1',//DESENVOLVIMENTO
  jornada_api_hapvida_localhost: 'http://localhost:8080/wssrvonline/v1',//localhost

   url_base_host: window.location.host,
   version_cvs: '1.66', // Versao do portal no CVS

};

